import districts from 'constants/Districts';

export const hasRegionsInside = (items) => {
  const hasItemsInside = items.reduce((acc, item) => {
    if (districts[item.id - 1] !== undefined) {
      return acc + 1;
    }

    return acc;
  }, 0);

  return hasItemsInside > 0;
};



// WEBPACK FOOTER //
// ./src/components/SearchFullscreen/helpers.js